import { AlertContext, Builder_, Confirmation_, device, Grey_, Grey_Link, Main_, Main_Plain, Textarea_ } from "monica-alexandria";
import { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import l from "../../../services/api/Landings";
import { alertMessage } from "../../../helpers/messagesAlerts";

/* ─────────────────────────────
   Styled Components
───────────────────────────── */

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: calc(100vh - 6rem);
  overflow: auto;
  padding: 0rem 0 4rem 0;
`;

const NotesList = styled.div`
  display: flex;
  flex-direction: column;
  gap:0.5rem;
`;


const NoteItem = styled.div`
  background: ${p=> p.theme.low};
  padding: var(--smallPads);
  border-radius: var(--smallRadius);
  margin: 0 2rem;

  @media ${device.md} {
    /* padding: 0 2rem; */
    margin: 0px;
  }
`;

const NoteHeader = styled.div`
  /* display: flex;
  align-items: center;
  justify-content: space-between; */
`;

const NoteActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  gap: 1rem;
  padding-top: 1rem;
`;

const NoteHeaderText = styled.div`
  display: flex;
  align-items: center;
  gap:1rem;
`

const Author = styled.h6`
`;

const DateText = styled.h6`
  opacity: 0.7;
`;


const NoteText = styled.div`
  padding-top: 0.5rem;

  h5 {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
`;

const AddNoteBox = styled.div`
  margin-bottom: 2rem;
  padding: var(--smallPads);
  position: sticky;
  top: 0rem;
  /* background: ${p => p.theme.mid}; */
  z-index: 5;
  box-shadow: 0 -2px 5px ${p => p.shadow};

  @media ${device.md} {
    /* padding: 0 2rem; */
  }
`;

const Actions = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
`;


const EditingNote = styled.div`
  padding-top: 1rem;
`

/* ─────────────────────────────
   Component
───────────────────────────── */

export default function Crm_Lead_Notes({ notes = [],setNotes, currentUserId, currentUserName, currentUserEmail, leadId, text, setText, handleAdd, mode}) {
  // const [text, setText] = useState("");
  const [isComposing, setIsComposing] = useState(false);
  const { t } = useTranslation();
  const [noteToDelete,setNoteToDelete] = useState(false)
	const {alerts,setAlerts} = useContext(AlertContext);
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [editingText, setEditingText] = useState("");

  const [localNotes, setLocalNotes] = useState(notes);

  const getAuthorLabel = (note = {}) => {
    const noteAuthorName = String(note?.createdByName || "").trim();
    const noteAuthorEmail = String(note?.createdByEmail || "").trim();
    const viewerEmail = String(currentUserEmail || "").trim();
    const isCurrentUser =
      String(note?.createdBy || "") === String(currentUserId || "") ||
      (noteAuthorEmail && viewerEmail && noteAuthorEmail.toLowerCase() === viewerEmail.toLowerCase());

    if (isCurrentUser) return t("You");
    if (noteAuthorName) return noteAuthorName;
    if (noteAuthorEmail) return noteAuthorEmail;
    if (note?.createdBy) return t("Team member");
    return t("Unknown author");
  };

  const startEdit = (note) => {
    setEditingNoteId(note._id);
    setEditingText(note.text);
  };


const cancelEdit = () => {
  setEditingNoteId(null);
  setEditingText("");
};


const saveEdit = async (noteId) => {
  const trimmed = editingText.trim();
  if (!trimmed) return;

  const snapshot = notes;
  const optimisticUpdatedAt = new Date().toISOString();

  // optimistic update
  setNotes(prev =>
    prev.map(n =>
      n._id === noteId
        ? { ...n, text: trimmed, updatedAt: optimisticUpdatedAt }
        : n
    )
  );

  setEditingNoteId(null);
  setEditingText("");


  console.log('eadId, noteId, trimmed', leadId, noteId, trimmed);
  if (mode==='edit') {
      try {
        const updatedNote = await l.editNote(leadId, noteId, trimmed);
        const normalizedNote =
          updatedNote?.data?.note ||
          updatedNote?.data ||
          null;
        console.log('updatedNote', updatedNote);
        
        // replace with backend version
        setNotes(prev =>
          prev.map(n =>
            n._id === noteId
              ? (
                  normalizedNote &&
                  typeof normalizedNote === "object" &&
                  normalizedNote.text !== undefined
                )
                ? normalizedNote
                : { ...n, text: trimmed, updatedAt: optimisticUpdatedAt }
              : n
          )
        );

        alertMessage(alerts, setAlerts, t("Note updated successfully"), "Success");
      } catch (err) {
        // rollback
        setNotes(snapshot);
        alertMessage(alerts, setAlerts, t("Failed to update note"), "Error");
      }
  }
};

const handleDelete = async (noteId) => {

  const snapshot = notes;

  setNotes(prev =>
    prev.filter(n => (n._id || n._tempId) !== noteId)
  );

  //  If note is not yet saved → no backend call
  if (noteId.startsWith("temp_")) return;

  try {
    await l.deleteNote(leadId, noteId);


    alertMessage(alerts, setAlerts,  (t('Note deleted successfully')), 'Success');
  } catch (err) {
    alertMessage(alerts, setAlerts,  (t('There was an error trying to delete this note')), 'Error');
    console.error("Delete note failed", err);
    // Rollback on failure
    setLocalNotes(snapshot);
  }

  setNoteToDelete({})
};

  const handleCancel = () => {
    setText("");
    setIsComposing(false);
  };

  const handleKeyDown = (event) => {
    if ((event.metaKey || event.ctrlKey) && event.key === "Enter") {
      event.preventDefault();
      handleAdd();
    }
  };
  const handleBlur = () => {
    if (!text.trim()) {
      setIsComposing(false);
    }
  };

  // const {
  //   notes: localNotes,
  //   addNote,
  //   editNote,
  //   deleteNote,
  // } = useNotesController({
  //   initialNotes: notes,
  //   leadId,
  //   currentUserId,
  //   onNotesChange,
  // });s
  console.log('NOTES', localNotes, notes);
  console.log('MODE', mode);
  // console.log('editinLead', edi, notes);
  
  return (
    <Wrapper>
      {noteToDelete.confirm ?
        <Confirmation_
          message={t("Are you sure you want to delete")+' "'+ noteToDelete.text+'"?'}
          no={t("No")}
          onNo={() => setNoteToDelete({})}
          onYes={() => handleDelete(noteToDelete.id)}
          yes={t("Yes")}
        />
      : null}
      <AddNoteBox>
        <Builder_>
          <Textarea_
            value={text}
            onChange={(e) => setText(e.target.value)}
            onFocus={() => setIsComposing(true)}
            onKeyDown={handleKeyDown}
            placeholder={t("Write a note")}
            rows={isComposing || text ? 3 : 1}
            onBlur={handleBlur}
          />
        </Builder_>
        {(isComposing || text) && (
          <Actions>
            <Main_ text={t("Add")} noPadding  size="small" onClick={handleAdd} disabled={!text.trim()} />
            <Grey_Link text={t("Cancel")} noPadding size="small" onClick={handleCancel} />
          </Actions>
        )}
      </AddNoteBox>
      <NotesList>
        {/* {normalizedNotes.length === 0 && (
          <EmptyState>{t("No notes yet")}</EmptyState>
        )} */}
        {notes?.map((note) => (
          <NoteItem key={note?._id || note?._tempId || note?.text}>
            <NoteHeader>
              <NoteHeaderText>
                {/* <Author>
                  {note.createdBy === currentUserId ? t("You") : t("Admin")}
                </Author> */}
                <Author>{getAuthorLabel(note)}</Author>
                <DateText>
                  {note?.createdAt
                    ? new Date(note.createdAt).toLocaleString()
                    : t("Unknown date")}
                </DateText>
              </NoteHeaderText>
              {/* <Grey_  
                iconLeft='Xicon'
                size='small'
                onClick= {()=>setNoteToDelete({id: note._id || note._tempId, text: note.text, confirm: true})}
                // onClick={() => handleDelete(note._id || note._tempId)}
              /> */}
            </NoteHeader>
            {editingNoteId === note?._id ? (
              <EditingNote>
                <Textarea_
                  value={editingText}
                  onChange={(e) => setEditingText(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      saveEdit(note?._id);
                    }
                    if (e.key === "Escape") cancelEdit();
                  }}
                  placeholder={t("Edit")}
                  rows={3}
                  autoFocus
                  // onBlur={cancelEdit}
                />
                <NoteActions  >
                  <Main_Plain text={t("Save")} noPadding size="small" onClick={() => saveEdit(note._id)} disabled={!editingText.trim()} />
                  <Grey_Link text={t("Cancel")} noPadding size="small" onClick={cancelEdit} />
                </NoteActions>
              </EditingNote>
            ) : (
              <div>
                <NoteText><h5>{note?.text}</h5></NoteText>
                <NoteActions>
                  <Grey_Link text={t('Edit')} noPadding size='small' onClick={() => startEdit(note)}/>
                  <Grey_Link text={t('Delete')}  noPadding size='small'  
                    onClick= {()=>{
                      mode==='edit'?
                        //needs confirmation
                        setNoteToDelete({id: note._id || note._tempId, text: note.text, confirm: true})
                      :
                        handleDelete(note._id || note._tempId)
                      }} /> 
                </NoteActions>
              </div>
            )}
          </NoteItem>
        ))}
      </NotesList>

    </Wrapper>
  );
}
